import { css } from '@emotion/react';

export const contactLandownerButtonStyles = css`
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
